import React, { useState } from 'react';
import SingleColor from './SingleColor';

import Values from 'values.js';

function App() {
  const [color, setColor] = useState('');
  const [error, setError] = useState(false);

  let colors = new Values('#123456').all(10);
  const [cList, setCList] = useState(colors);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setError(false);
    try {
      let colors = new Values(color).all(10);
      setCList(colors);
    } catch (error) {
      setError(true);
    }
  };

  return (
    <>
      <section className='container'>
        <h3>color generator</h3>
        <form onSubmit={handleSubmit}>
          <input
            type='text'
            value={color}
            onChange={(evt) => setColor(evt.target.value)}
            placeholder='#123456'
            className={error ? 'error' : undefined}
          />
          <button type='submit' className='btn'>
            Submit
          </button>
        </form>
      </section>
      <section className='colors'>
        {cList.map((color, index) => {
          return <SingleColor key={index} {...color} index={index} />;
        })}
      </section>
    </>
  );
}

export default App;
